import { toDate, toNull, toNumber, toUUID } from "shared/lib/zod/utils"
import { ProjectSchema } from "shared/types/__generated__/validation"

const schema = ProjectSchema()

export const CreateProjectTransformSchema = schema.extend({
  id: schema.shape.id.transform(toUUID),
  position: schema.shape.position.nullish().transform(toNumber),
  description: schema.shape.description.nullish().transform(toNull),
  createdAt: schema.shape.createdAt.nullish().transform(toDate),
  updatedAt: schema.shape.updatedAt.nullish().transform(toDate),
  lastChanged: schema.shape.lastChanged.nullish().transform(toDate),
  hasClarificationRequest: schema.shape.hasClarificationRequest
    .nullish()
    .transform(toNull),
  team: schema.shape.team.nullish().transform(toNull),
  phase: schema.shape.phase.transform(toNull),
  lastChangedBy: schema.shape.lastChangedBy.nullish().transform(toNull),
  priceList: schema.shape.priceList.nullish().transform(toNull),
  inflationSurcharge: schema.shape.inflationSurcharge
    .nullish()
    .transform(toNull),
  specialPriceGroups: schema.shape.specialPriceGroups
    .nullish()
    .transform(toNull),
  children: schema.shape.children.nullish().transform(() => []),
  ui: schema.shape.ui.transform(toNull)
})
